import {configureStore} from '@reduxjs/toolkit';

import authReducer from '@/store/authSlice'
import assistantReducer from './assistantSlice';
import logsReducer from '@/store/logsSlice'

export const store = configureStore({
    reducer: {
        auth: authReducer,
        assistant: assistantReducer,
        logs: logsReducer
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
